import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div style="margin-top:20px; position:relative; height:200px" ng-if="vm.loading">
            <div class="loader02">{{ 'evaluation.Please wait! Loading report' | translate }}</div>
        </div>
        <ng-container ng-if="!vm.loading">
            <ul class="actions01 print-hide" style="margin-bottom: 20px;">
                <li class="primary">
                    <button class="btn bordered02 main" ng-click="vm.print()">
                        <i class="glyphicon glyphicon-print"></i>
                        {{ 'report.Print to PDF' | translate }}
                    </button>
                </li>
            </ul>
            <evaluation-public-report-title report="vm.report" company="vm.company" language="vm.language" />
            <p></p>
            <ul class="metablock nomargin page-break" ng-if="!vm.report.isEvaluableReport">
                <li>
                    <div class="label">{{ 'evaluation.Report input (blue bar)' | translate }}</div>
                    <div class="value">{{ vm.report.inputTitle }}</div>
                </li>
                <li ng-if="vm.report.comparisonTitle">
                    <div class="label">{{ 'evaluation.Comparison value (red line)' | translate }}</div>
                    <div class="value">{{ vm.report.comparisonTitle }}</div>
                </li>
                <li ng-if="vm.comparisonReport && vm.comparisonReport.inputTitle">
                    <div class="label">{{ 'evaluation.Previous results comparison feedbackgroup (grey bar)' | translate }}</div>
                    <div class="value">{{ vm.comparisonReport.groupName }}</div>
                </li>
            </ul>
            <p></p>
            <h2 class="page-break">{{ 'report.Introduction' | translate }}</h2>
            <p ng-bind-html="vm.introductionText"></p>
            <h2>{{ 'report.How to interpret results?' | translate }}</h2>
            <p ng-bind-html="vm.resultsText"></p>
            <h2 class="page-break">{{ 'report.Response Statistics' | translate }}</h2>
            <evaluation-public-report-role
                roles-form="vm.report.rolesForm"
                statistics-text="vm.statisticsText"
                is-evaluable-report="vm.report.isEvaluableReport"
            />
            <p></p>
            <h2 class="page-break">{{ 'report.Aggregate summary' | translate }}</h2>
            <evaluation-public-report-category-summary
                is-evaluable-report="vm.report.isEvaluableReport"
                report="vm.report"
                comparison-report="vm.comparisonReport"
                summary-text="vm.summaryText"
            />

            <h2 ng-if="vm.report.isEvaluableReport">{{ 'report.Your Highest and Lowest Scores' | translate }}</h2>
            <p ng-if="vm.scoresText" ng-bind-html="vm.scoresText"></p>
            <evaluation-public-report-score
                ng-if="vm.report.isEvaluableReport"
                type="'highest'"
                is-evaluable-report="vm.report.isEvaluableReport"
                questions="vm.report.highestScoreQuestions"
                question-counter="vm.questionCounter"
                />
            <evaluation-public-report-score
                ng-if="vm.report.isEvaluableReport"
                type="'lowest'"
                is-evaluable-report="vm.report.isEvaluableReport"
                questions="vm.report.lowestScoreQuestions"
                question-counter="vm.questionCounter"
            />
            <evaluation-public-report-category-results
                report="vm.report"
                comparison-report="vm.comparisonReport"
                show-averages="!vm.report.isEvaluableReport"
                question-counter="vm.questionCounter"
            />
            <evaluation-public-report-results
                ng-if="vm.report.isEvaluableReport"
                question-counter="vm.questionCounter"
                report="vm.report"
                comparison-report="vm.comparisonReport"
            />
        </ng-container>
    `
})
export default class {
    constructor ($q, $rootScope, $scope, $state, $location, $translate, lodash, EvaluationGroupEvaluationResource,
                 CompanyResource, EvaluationReportGroupService, EvaluationReportSingleService,
                 TokenService, TranslationService) {
        this.$q = $q;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$location = $location;
        this.$translate = $translate;
        this.lodash = lodash;
        this.EvaluationGroupEvaluationResource = EvaluationGroupEvaluationResource;
        this.CompanyResource = CompanyResource;
        this.EvaluationReportGroupService = EvaluationReportGroupService;
        this.EvaluationReportSingleService = EvaluationReportSingleService;
        this.TokenService = TokenService;
        this.TranslationService = TranslationService;

        const listener = $rootScope.$on('evaluation:language', (event, language) => {
            this.language = language;
            this.loadReport();
        });
        $scope.$on('$destroy', listener);
    }

    $onInit () {
        this.loadReport();
    }

    print () {
        window.print();
    }

    loadReport () {
        this.loading = true;
        const promises = {
            report: this.getReport(this.$state.params.guid)
        };
        if (this.$state.params.comparisonGuid) {
            promises.comparisonReport = this.getReport(this.$state.params.comparisonGuid);
        }
        this.$q
            .all(promises)
            .then(reports => {
                this.report = reports.report;
                if (reports.comparisonReport) {
                    this.comparisonReport = reports.comparisonReport;
                }
                this.initQuestionCounter();
                this.$rootScope.report = this.report;
                this.CompanyResource.publicView({
                    id: this.report.companyId,
                    expand: 'companyI18ns,languages'
                }).$promise.then(company => {
                    this.company = company;
                    this.$rootScope.company = company;
                    this.initLanguageFromCompany(company).then(() => {
                        this.loadTexts();
                        this.loading = false;
                    });
                });
            });
    }

    /**
     * If user is not logged in, switch to company default language
     * @param {Object} company
     * @returns {Promise}
     */
    initLanguageFromCompany (company) {
        const urlLang = this.$location.search().lang;
        if (urlLang) {
            return this.$q.resolve();
        }
        if (!this.TokenService.hasToken() && company.defaultLanguage) {
            const companyLang = company.defaultLanguage.toLowerCase();
            const currentLang = this.$translate.use();
            if (currentLang !== companyLang) {
                return this.TranslationService.changeLanguage(companyLang).then(() => {
                    this.language = companyLang;
                });
            }
        }
        return this.$q.resolve();
    }

    loadTexts () {
        const { EvaluationReportGroupService, EvaluationReportSingleService, report, company } = this;
        const language = this.$translate.use().toUpperCase();
        const companyI18n = this.lodash.find(company.companyI18ns, i18n => i18n.language === language);
        if (report.isEvaluableReport) {
            this.introductionText = EvaluationReportSingleService.getIntroduction(companyI18n);
            this.resultsText = EvaluationReportSingleService.getResults(companyI18n);
            this.statisticsText = EvaluationReportSingleService.getStatistics(companyI18n);
            this.summaryText = EvaluationReportSingleService.getSummary(companyI18n);
            this.scoresText = EvaluationReportSingleService.getScores(companyI18n);
        }
        else {
            this.introductionText = EvaluationReportGroupService.getIntroduction(companyI18n);
            this.resultsText = EvaluationReportGroupService.getResults(companyI18n);
            this.statisticsText = EvaluationReportGroupService.getStatistics(companyI18n);
            this.summaryText = EvaluationReportGroupService.getSummary(companyI18n);
        }
    }

    getReport (guid) {
        return this.EvaluationGroupEvaluationResource.report({
            guid,
            _lang: this.language,
            siteId: this.$state.params.siteId,
            comparisonSiteId: this.$state.params.comparisonSiteId
        }).$promise;
    }

    initQuestionCounter () {
        this.questionCounter = {};
        let counter = 1;
        this.lodash.forEach(this.report.categoriesForm.categories, (category) => {
            this.lodash.forEach(category.questions, (question) => {
                this.questionCounter[question.id] = counter;
                counter = counter + 1;
            });
        });
        this.lodash.forEach(this.report.categoriesForm.questionsWithoutCategories, (question) => {
            this.questionCounter[question.id] = counter;
            counter = counter + 1;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/evaluation/public/report/index.js